import { useCallback } from 'react';
import { useLogGoodsAnalyticsEvent } from './useLogGoodsAnalyticsEvent';

export const useLogClickCart = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();

  return useCallback(() => {
    logGoodsAnalytics({
      name: 'CLICK_CART',
      analytics: {
        SCREEN: 'GOODS_DETAIL',
      },
    });
  }, [logGoodsAnalytics]);
};
